import axios from "axios";
import interfaceUserRegister from "../types/user.interface";

const user = JSON.parse(localStorage.getItem("user") ?? "false");

class UsersService {
  async getAll() {
    return await axios.get("users");
  }
  async createUser(user: interfaceUserRegister) {
    return await axios.post("register", user);
  }
  async getId(id: number) {
    return await axios.get(`users/${id}`);
  }

  async updateUser(id: number, values: any) {
    return await axios.put(`users/${id}`, values);
  }

  async deletecUser(id: number) {
    return await axios.delete(`users/${id}`);
  }

  async changePW(data: {
    id: number;
    password: string;
    password_confirm: string;
  }) {
    return await axios.put("users/password", data);
  }
}

export default new UsersService();
